import { render, staticRenderFns } from "./TrainerWorkoutHistoryDialog.vue?vue&type=template&id=375902f3"
import script from "./TrainerWorkoutHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TrainerWorkoutHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports